import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import ChatBox from './ChatBox';

const InfoIcon = ({children, ...props}) => {
    return (
        <div className="info-icon-container" id="info-icon-container">
            <FontAwesomeIcon className="info-icon" {...props} icon={faInfoCircle} />
            {/*<ChatBox className="chatbox">{children}</ChatBox>*/}
        </div>
    );
};

export default InfoIcon;
